<div *ngIf="mismatch || noZone" class="profile-time-zone-banner" role="status">
  <i class="fa-regular fa-clock profile-time-zone-banner__icon" aria-hidden="true"></i>
  <span *ngIf="mismatch" class="profile-time-zone-banner__text">
    Your profile time zone is <strong>{{ mismatch.profileName }}</strong>, but this browser is in
    <strong>{{ mismatch.browserName }}</strong>.
  </span>
  <!-- ITP-E-335-04: no profile zone yet. A browser that can't name its zone leaves the second sentence out. -->
  <span *ngIf="noZone" class="profile-time-zone-banner__text">
    Your profile has no time zone yet.<ng-container *ngIf="noZone.browserName"> This browser is in
    <strong>{{ noZone.browserName }}</strong>.</ng-container>
  </span>
  <div class="profile-time-zone-banner__actions">
    <button type="button" class="profile-time-zone-banner__update" (click)="updateProfile()">{{ mismatch ? 'Update profile' : 'Set time zone' }}</button>
    <button type="button" class="profile-time-zone-banner__dismiss" (click)="dismiss()">Dismiss</button>
  </div>
</div>
